import { MAP_SETTINGS_LOADING_SET } from './mapSettingsLoading.actionTypes';

export const mapSettingLoadingSet = (isLoading: boolean) => ({
  type: MAP_SETTINGS_LOADING_SET,
  payload: {
    isLoading,
  },
}) as const;
